export const environment = {
    production: true,
    // url: 'https://apigestao.goetech.com.br/api/',
    url: 'https://api.plataformagoverno360.com.br/api/',
    // url: 'http://localhost:3001/api/',
    googleKey: 'AIzaSyCZ8_9YAe1gSLcVuIjC9Bs9uEypjFdv4-g',
    title: 'Governo360',
    iconRef: 'governo'
};
